<template>
    <div class="mt10vw txt-center lh1_5em fs13px txt-gray" @click="handleClick">
        <p><slot>本页一句话操作提示语</slot></p>
        <p :class="isWxBrowser ? 'txt-link' : 'txt-link-blue'">操作指南及常见问题</p>
    </div>
</template>

<script>
    import Utils from '../utils';

    export default {
        name: 'Help',
        props: {
            link: {
                type: String,
                default: '',
            },
        },
        computed: {
            isWxBrowser() {
                return Utils.env.isWxBrowser();
            },
        },
        methods: {
            handleClick() {
                if (this.link.length > 0) {
                    window.location.href = this.link;
                }
            },
        },
    };
</script>

<style scoped>

</style>
